import { IMissionPlanProfilNav } from '../iris/missionPlan/IMissionPlanProfilNav'
import { IMissionPlanStep } from '../iris/missionPlan/IMissionPlanStep'
import { IMissionPlanWaypoint } from '../iris/missionPlan/IMissionPlanWaypoint'
import { AloMission } from '../alo/AloMission'
import {IMissionPlan} from '@/models/iris/missionPlan/IMissionPlan'
import { IMissionPlanProfilSci } from '../iris/missionPlan/IMissionPlanProfilSci'
import { IMissionSensor } from '../iris/missionPlan/IMissionSensor'

export class MissionPlanUiState {
    
    public typeUiid:string
    public hoverWptId:number
    public showGlobalWpts:boolean
    public hoverStepId:number
    public hoverPrfId:number
    public currentEditProfil:IMissionPlanProfilNav
    public currentEditProfilSci:IMissionPlanProfilSci
    public currentEditStep:IMissionPlanStep
    public currentEditWpt:IMissionPlanWaypoint
    public currentEditSensor:IMissionSensor
    public drawMode:string //mode d'ajout de point step or wpt // = ""
    public lastActionId:number
    public missionPlan:IMissionPlan
    public enablePayload:boolean
    public payloadAutoSet:boolean
        
    constructor({
                typeUiid="mission", //mission ou template
                showGlobalWpts = false,
                hoverWptId = -1, 
                hoverStepId = -1,
                hoverPrfId = -1,
                currentEditProfil = MissionPlanUiState.getDefaultProfil(),
                currentEditProfilSci = MissionPlanUiState.getDefaultProfilSci(),
                currentEditStep = MissionPlanUiState.getDefaultStep(),
                currentEditWpt = MissionPlanUiState.getDefaultWayPoint(),
                currentEditSensor= MissionPlanUiState.getDefaultSensor(),
                drawMode = "",
                lastActionId = -1,
                missionPlan = MissionPlanUiState.getDefaultMissionPlan(),
                enablePayload = false,
                payloadAutoSet = false
            } = {}) {  
        this.typeUiid = typeUiid
        this.showGlobalWpts = showGlobalWpts
        this.hoverWptId = hoverWptId
        this.hoverStepId = hoverStepId
        this.hoverPrfId = hoverPrfId        
        this.currentEditProfil = {...currentEditProfil}
        this.currentEditProfilSci = {...currentEditProfilSci}
        this.currentEditStep = {...currentEditStep}
        this.currentEditWpt = {...currentEditWpt}
        this.currentEditSensor = {...currentEditSensor}
        this.drawMode = drawMode
        this.lastActionId = lastActionId
        this.missionPlan = missionPlan
        this.enablePayload = enablePayload
        this.payloadAutoSet = payloadAutoSet
    }

    public static getDefaultProfil()
    {
        return {prf_label:"Standard",bd:-1015,bu:1015,pd:-1020,pu:1020,sr:1,zb:30,zt:2,zs:2,alt:30,current_correction:true,flasher:false,radio:false,navigation_mode:'waypoint'} as IMissionPlanProfilNav
    } 

    public static getDefaultSensor()
    {
        return {snr_label:""} as IMissionSensor
    }

    public static getDefaultProfilSci()
    {
        return {prf_label:"",sensors:{}} as IMissionPlanProfilSci
    } 

    public static getDefaultStep(){
        return {rVal:0,tVal:0,payload_enable:true,prfSci_id:-1,prfNav_id:-1} as IMissionPlanStep
        // id:number               //Identifiant de step unique dans le fichier    
        // nextStep_id:number|null //Identifiants du step suivant
        // rVal:number             //distance de validation du WayPoint – rayon de validation
        // tVal:number             //Temps (s) à rester sur le Point une fois la distance validé – 0 par défault
        // wpt_id:number           //Identifiant du WayPoint associé à cette step
        // prfNav_id:number        //Identifiant du profile de vol à appliquer à ce step
        // prfSci_id:number        //Identifiant du profile sci à appliquer à ce step
        // payload_enable:boolean  //Id
    } 

    public static getDefaultWayPoint(){
        return {wpt_label:"",wpt_lat:0,wpt_lon:0} as IMissionPlanWaypoint
    }

    public static getDefaultMissionPlan(mission:AloMission|null = null)
    {
      return {
        cur_step: -1,		//Numéro du step courant suivi
        gli_key: mission?.gliKey ?? "",	//Identifiant du glider
        gli_msn: mission?.misIdx ?? -1,		//Numéro de mission iris glider courante 
        rval_since: 0,		//timestamp date ou le waypoint a été validé – Dispo qu’avec le verbe GET
        step_since: 0,
        steps:[],
        wpts:[],
        prf_nav:[],
        prf_sci:[],
        payload:[],
        dat_pub:null
      }
    } 

    public static parseMissionPlan(json?:string|null,mission:AloMission|null = null)
    {
        const mission_plan =   {...MissionPlanUiState.getDefaultMissionPlan(mission),...JSON.parse(json??'{}')}  as IMissionPlan
        mission_plan.steps = mission_plan.steps.filter(s => !!s)
        //s'assure du bon format des nav
        mission_plan.prf_nav = mission_plan.prf_nav.map(pn => ({...MissionPlanUiState.getDefaultProfil(),...pn}))
        //s'assure du bon format des prfSci
        mission_plan.prf_sci = mission_plan.prf_sci.map(ps => {
            const p = {...MissionPlanUiState.getDefaultProfilSci(),...ps}                
            Object.keys(p.sensors).forEach(k =>{          
                const sensor = p.sensors[Number.parseInt(k)]
                //@ts-ignore
                p.sensors[Number.parseInt(k)] = [sensor?.at(0) ?? 1, sensor?.at(1)?.toString()?.padStart(3,'0') ?? "111",sensor?.at(2) ?? 1]
            })        
            return p
        })

        return mission_plan
    }
} 

export const buildMissionPlanStateId = (id:number,typeuiid:string) => {
    return `missionplan_${id}_${typeuiid}`
}